import { Localized } from 'dg-web-shared/lib/Localization';
import { LicensePlateCountry } from 'dg-web-shared/dto/LicensePlateCountry';
import { useLoggedParkingaboServerWrite } from '../../../api/ParkingaboApi';
import {
    VehicleForm,
    VehicleOnboardingPayload,
} from '../../../components/forms/VehicleForm';
import { ParkingaboAsyncLoadedSection } from '../../../components/layout/ParkingaboAsyncLoadedSection';
import {
    useNavigateOnSuccess,
    useServerFetch,
    useServerSuccessEffect,
} from 'dg-web-shared/lib/hooks/ServerStateHooks';
import { ParkingaboLayoutWithHeader } from '../../../components/layout/ParkingaboLayoutWithHeader';
import { ParkingaboRoutedModal } from '../../../components/layout/ParkingaboRoutedModal';
import { makeCountryOptions } from '../../../hooks/UseCountryFetch.tsx';
import { useCustomerContext } from '../../../components/CustomerProvider.tsx';

export function AddVehicleRoute() {
    const { vehicles } = useCustomerContext();

    const [countriesState] = useServerFetch<LicensePlateCountry[], object>(
        () => ({
            url: `/ui-api/parkingabo/license-plate-countries`,
        }),
        {},
    );

    const [state, submit] = useLoggedParkingaboServerWrite<
        VehicleOnboardingPayload,
        string
    >('add-vehicle', () => ({
        url: 'user/self/vehicles',
    }));

    useServerSuccessEffect(state, vehicles.refetch);
    useNavigateOnSuccess(state, '..');

    return (
        <ParkingaboRoutedModal
            open={true}
            backUrl={'..'}
            render={() => (
                <ParkingaboLayoutWithHeader
                    backTo={'..'}
                    title={
                        <Localized
                            de="Fahrzeug hinzufügen"
                            fr="Ajouter un véhicule"
                            it="Aggiungi veicolo"
                            en="Add vehicle"
                        />
                    }
                >
                    <ParkingaboAsyncLoadedSection
                        state={countriesState}
                        render={data => {
                            return (
                                <VehicleForm
                                    countriesOptions={makeCountryOptions(data)}
                                    requestState={state}
                                    submit={submit}
                                />
                            );
                        }}
                    />
                </ParkingaboLayoutWithHeader>
            )}
        />
    );
}
